import CampaignService from '@/api/CampaignService';
import { IRouterProps } from '@/router/interfaces/router-props.interface';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '../types';
import { StripeState } from './stripeType';
import { getQueryStringValue } from '@/router/router-utils';
import Module from '../interfaces/module.interface';
import { IBusinessType } from '@/models/business';

export const state: StripeState = new StripeState('', '', '', 0, '');

const campaignService = new CampaignService();

const factory = async (context: IRouterProps) => {
  if (
    context.auth === 'manager' &&
    context.routeRequirements.managerHaveBusiness &&
    context.store.getters['business/getBusinessType'] !== IBusinessType.ONLINE
  ) {
    let stripeData: any = { requestFailed: true };

    try {
      const response = await campaignService.checkBusiness();
      stripeData = response.data;
    } finally {
      context.store.dispatch('stripe/SET_STRIPE_DATA', stripeData);
    }

    if (stripeData && !stripeData.requestFailed) {
      const connection = getQueryStringValue('stripe_connection');
      if (connection === 'success') {
        context.store.dispatch(
          'stripe/SET_STRIPE_PROFILE',
          stripeData.payment.url
        );
      }

      context.store.dispatch(
        'stripe/SET_STRIPE_CONNECT',
        stripeData.payment.url
      );
      context.store.dispatch('stripe/SET_STRIPE_CONNECTION', connection);
    }
  }
};

const actions: ActionTree<StripeState, RootState> = {
  SET_STRIPE_CONNECTION(context, payload: StripeState) {
    context.commit('setConnection', payload);
  },
  SET_STRIPE_PROFILE(context, payload: StripeState) {
    context.commit('setProfileURL', payload);
  },
  SET_STRIPE_CONNECT(context, payload: StripeState) {
    context.commit('setConnectURL', payload);
  },
  SET_STRIPE_STEP(context, payload: StripeState) {
    context.commit('setStep', payload);
  },
  SET_STRIPE_DATA(context, payload: StripeState) {
    context.commit('setData', payload);
  }
};

const mutations: MutationTree<StripeState> = {
  setConnection(state, payload: string) {
    state.connection = payload;
  },
  setProfileURL(state, payload: string) {
    state.profileURL = payload;
  },
  setConnectURL(state, payload: string) {
    state.connectURL = payload;
  },
  setStep(state, payload: number) {
    state.step = payload;
  },
  setData(state, payload: any) {
    state.data = payload;
  }
};

const getters: GetterTree<StripeState, RootState> = {
  getProfile(state) {
    return state.profileURL;
  },
  getData(state) {
    return state.data;
  }
};

const namespaced: boolean = true;

export const stripe: Module<StripeState, RootState> = {
  namespaced,
  initializer: {
    factory,
    provide: 'StripeStore',
    requires: ['BusinessStore'],
    on: 'BeforeEachRoute'
  },
  state,
  actions,
  mutations,
  getters
};
